import BreakingDealsCarouselContainerMobile from '../../../../components/containers/BreakingDealsCarouselContainerMobile';
import preloadCustomProps from '../../../utils/preloads/preloadBreakingDealsProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'breaking-deals-carousel--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  containerConfig: {
    settings: {
      instance: BreakingDealsCarouselContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
